import React, { useEffect, useState } from "react";
import { MdOutlineCancel } from "react-icons/md";

import { Button } from ".";
import { userProfileData } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import avatar from "../data/avatar.jpg";
import axios from "axios";
import { baseUrl } from "../data/baseURL";

const UserProfile = () => {
  const { currentColor } = useStateContext();

  const [profile, setProfile] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}/Auth`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setProfile(response.data.data);
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="nav-item absolute end-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">
          اطلاعات کاربر
        </p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      {profile && (
        <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
          <div>
            <p className="font-semibold text-xl dark:text-gray-200">
              {" "}
              {profile.firstName + " " + profile.lastName}
            </p>
            <p className="text-gray-500 text-sm font-semibold dark:text-gray-400">
              {" "}
              {profile.phoneNumber}{" "}
            </p>
          </div>
        </div>
      )}
      <div></div>
      <div
        className="mt-5"
        onClick={() => {
          localStorage.clear("token");
          window.location.reload();
        }}
      >
        <Button
          color="white"
          bgColor={currentColor}
          text="خروج از حساب کاربری"
          borderRadius="10px"
          width="full"
        />
      </div>
    </div>
  );
};

export default UserProfile;
